import React from "react"
import { Spinner } from "reactstrap"
import { useTranslation } from "react-i18next"

const LoadingSpinner = ({ text }) => {
  const { t } = useTranslation()
  return (
    <div className="text-center py-5">
      <Spinner color="primary" />
      <p className="mt-2 text-muted">{text || t("Loading")}</p>
    </div>
  )
}

export default LoadingSpinner
